<template>
<div class="container">

  <ul class="docCreation" v-if="to_editor === 'true'">
    <li v-for="t in matterTypes">
      <router-link :to="'/docs/choosetype/true/' + t._id + '/none'">{{t.name}}</router-link>
    </li>
  </ul>

  <ul class="docCreation" v-else>
    <li v-for="t in matterTypes">
      <router-link :to="'/docs/choosetype/false/' + t._id + '/' + matter_id">{{t.name}}</router-link>
    </li>
  </ul>

</div>
</template>

<script>
import axios from 'axios'
import { bus } from '@/components/bus.js'
export default {
  name: 'chooseDocCategory',
  props: ['to_editor', 'matter_id'],
  data () {
    return {
      matterTypes: []
    }
  },
  created () {
    this.$root.$data.pageTitle = 'Document Categories'
    this.getTypes()
  },
  mounted () {
    bus.$emit('in_editor', true)
  },
  destroyed () {
    bus.$emit('in_editor', false)
  },
  methods: {
    getTypes () {
      axios.get('/api/types/matters/all')
      .then(res => {
        if (res.status === 200) {
          this.matterTypes = res.data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// chooseDocCategory.vue?ae4e63a6